import { FileText, PieChart, Table, Workflow } from 'lucide-react'
import type { ArtifactResponse } from '@/client/types.gen'
import { ArtifactMetadataBlock } from '@/components/project/artifact-viewer/ArtifactMetadataBlock'
import { useTranslation } from '@/hooks/useTranslation'

export interface OfficeFileViewerProps {
	artifact: ArtifactResponse
	category: 'word' | 'excel' | 'powerpoint' | 'visio'
	onDownload?: () => Promise<void>
	downloading?: boolean
}

const categoryIcons = {
	word: FileText,
	excel: Table,
	powerpoint: PieChart,
	visio: Workflow,
} as const

export function OfficeFileViewer({ artifact, category }: OfficeFileViewerProps) {
	const { t } = useTranslation()
	const Icon = categoryIcons[category]

	return (
		<div className="p-4 space-y-6">
			<div className="flex flex-col items-center justify-center py-8 text-center">
				<Icon className="size-16 text-muted-foreground shrink-0" aria-hidden />
				<p className="mt-4 text-base font-medium text-foreground">
					{t('pages.projectDetail.artifactPreview.previewNotAvailable')}
				</p>
				<p className="mt-1 text-sm text-muted-foreground">
					{t('pages.projectDetail.artifactPreview.previewNotAvailableDescription')}
				</p>
			</div>
			<ArtifactMetadataBlock artifact={artifact} />
		</div>
	)
}
